import React from 'react';
import { browserHistory, Router, Route, IndexRoute } from 'react-router';

import App from './App';
import NoVacancy from './containers/NoVacancy';
import FrontPage from './containers/Frontpage';
import Privacy from './pages/privacy.mdx';

const routes = (
  <Router history={browserHistory}>
    <Route path="/" component={ App }>
      <IndexRoute component={ FrontPage} />
      <Route path="/p/privacy" component={() => (<Privacy email="mail@kodyl.com" phone="+45 77 34 34 64" />)} />
      <Route path="/:code" component={ NoVacancy } />
    </Route>
  </Router>
);

export default routes;
